import { COLLECTION_MECHANIC } from '../../../models/collection-mechanic/collection-mechanic.types';
import { COLLECTION_METHOD_PDP } from '../partner-promotional-banner/partner-promotional-banner.types';
import { TabEntry } from './partner-info.types';

export const sortTabs = ([keyA]: TabEntry, [keyB]: TabEntry) => {
  if (keyA === COLLECTION_MECHANIC.EStore) {
    return -1;
  }
  if (keyB === COLLECTION_MECHANIC.EStore) {
    return 1;
  }
  return 0;
};

export const showPromotionBannerByCollectionMethod = (
  activeCollectionMethod: COLLECTION_MECHANIC,
  collectionMethod?: COLLECTION_METHOD_PDP | null,
) => {
  if (collectionMethod === COLLECTION_METHOD_PDP.Any) {
    return true;
  }

  switch (activeCollectionMethod) {
    case COLLECTION_MECHANIC.EStore: {
      return collectionMethod === COLLECTION_METHOD_PDP.Online;
    }
    case COLLECTION_MECHANIC.CLO: {
      return collectionMethod === COLLECTION_METHOD_PDP.InStore;
    }
    case COLLECTION_MECHANIC.Manual: {
      return collectionMethod === COLLECTION_METHOD_PDP.Manual;
    }
    default: {
      return false;
    }
  }
};
